import { useState } from 'react';
import styled from 'styled-components';
import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoChatbubbleEllipsesOutline,
} from 'react-icons/io5';
import { IEUM_BUSINESS_INFO } from '../../config/ieumConfig';
import { openMail } from '../../utils/openMail';
import { openChannelTalkWorkflow } from '../../services/channelTalkService';

const PlatformFooter = ({
  mailAddress = 'biz@ieum.in',
  channelTalkRole = 'realtor',
}) => {
  const [bizOpen, setBizOpen] = useState(false);
  const [mailToast, setMailToast] = useState(false);

  const handleChannelOpen = () => {
    openChannelTalkWorkflow(channelTalkRole);
  };

  const handleMailClick = async (e) => {
    e.preventDefault();
    const { copied } = await openMail(mailAddress);
    if (copied) {
      setMailToast(true);
      setTimeout(() => setMailToast(false), 2500);
    }
  };

  return (
    <Wrap>
      <SectionBox>
        <AccordionHeader type="button" onClick={() => setBizOpen((v) => !v)}>
          <BizTitleCol>
            <SectionTitle>이음 플렛폼 사업자 정보</SectionTitle>
            <BizTitleSub>(주)이음의 플렛폼 운영사 정보입니다</BizTitleSub>
          </BizTitleCol>
          {bizOpen ? <IoChevronUpOutline size={18} /> : <IoChevronDownOutline size={18} />}
        </AccordionHeader>
        {bizOpen && (
          <InfoGrid>
            <InfoRow><InfoKey>업체명</InfoKey><InfoVal>{IEUM_BUSINESS_INFO.companyName}</InfoVal></InfoRow>
            <InfoRow><InfoKey>대표자</InfoKey><InfoVal>{IEUM_BUSINESS_INFO.representative}</InfoVal></InfoRow>
            <InfoRow><InfoKey>사업자번호</InfoKey><InfoVal>{IEUM_BUSINESS_INFO.businessNumber}</InfoVal></InfoRow>
            <InfoRow><InfoKey>주소</InfoKey><InfoVal>{IEUM_BUSINESS_INFO.address}</InfoVal></InfoRow>
            <InfoRow><InfoKey>고객센터</InfoKey><InfoVal>{IEUM_BUSINESS_INFO.supportEmail}</InfoVal></InfoRow>
            <InfoRow><InfoKey>대표번호</InfoKey><InfoVal>{IEUM_BUSINESS_INFO.supportPhone}</InfoVal></InfoRow>
          </InfoGrid>
        )}
      </SectionBox>

      <TermsRow>
        <TermLink href="/terms/service" target="_blank" rel="noreferrer">이용약관</TermLink>
        <TermDivider />
        <TermLink href="/terms/privacy" target="_blank" rel="noreferrer">개인정보처리방침</TermLink>
        <TermDivider />
        <TermLink href="/terms/license" target="_blank" rel="noreferrer">오픈소스 라이선스</TermLink>
      </TermsRow>

      <SupportRow>
        <ChannelBtn type="button" onClick={handleChannelOpen}>
          <IoChatbubbleEllipsesOutline size={16} />
          채팅상담 (채널톡)
        </ChannelBtn>
        <MailLine>
          메일 문의 :
          <MailAnchor type="button" onClick={handleMailClick}>{mailAddress}</MailAnchor>
        </MailLine>
      </SupportRow>

      {mailToast && <MailToast>{mailAddress} 주소가 복사됐어요</MailToast>}
    </Wrap>
  );
};

export default PlatformFooter;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const SectionBox = styled.section`
  background: #F7F8FB;
  border: 1px solid #E8ECF2;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SectionTitle = styled.h2`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
`;

const BizTitleCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
`;

const BizTitleSub = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const AccordionHeader = styled.button`
  width: 100%;
  display: flex; align-items: center; justify-content: space-between;
  background: none; border: 0; padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const InfoGrid = styled.div`
  display: flex; flex-direction: column;
  margin-top: 6px;
`;

const InfoRow = styled.div`
  display: flex; justify-content: space-between; gap: 12px;
  padding: 8px 0;
  font-size: 13px;
  &:not(:last-of-type) { border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight}; }
`;

const InfoKey = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  flex-shrink: 0;
`;

const InfoVal = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-weight: 500;
  text-align: right;
  word-break: break-all;
`;

const TermsRow = styled.div`
  display: flex; justify-content: center; align-items: center;
  gap: 10px; flex-wrap: wrap;
  padding: 4px 0;
`;

const TermLink = styled.a`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
  text-decoration: none;
  &:hover { color: ${({ theme }) => theme.colors.text}; text-decoration: underline; }
`;

const TermDivider = styled.span`
  width: 1px;
  height: 10px;
  background: ${({ theme }) => theme.colors.border};
`;

const SupportRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 0 12px;
  flex-wrap: nowrap;
  min-width: 0;
`;

const ChannelBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 12px;
  background: #fff;
  color: ${({ theme }) => theme.colors.text};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover { background: #F9FAFB; }
`;

const MailLine = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  min-width: 0;
  flex-shrink: 1;
  overflow: hidden;
`;

const MailAnchor = styled.button`
  background: none;
  border: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
`;

const MailToast = styled.div`
  position: fixed;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(17, 24, 39, 0.92);
  color: #fff;
  padding: 12px 18px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  z-index: 9999;
`;
